customElements.get("product-modal") || customElements.define("product-modal", 
  class extends ModalDialog {
    constructor() {
        super();
    }

    hide() {
        super.hide();
    }

    show(event) {
        super.show(event);
        this.showActiveMedia();
        const activeHeight = this.querySelector(".active").clientHeight;
        this.addEventListener("mousemove", (e) => {
            const scrollTop = (e.clientY / window.innerHeight) * Math.abs(window.innerHeight - activeHeight);
            this.querySelector(".product-media-modal__content").scrollTo({
                top: scrollTop
            });
        });
    }

    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`)
            .forEach((media) => media.classList.remove("active"));
        console.log(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`)
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      console.log("activeMedia", activeMedia)
        const template = activeMedia.querySelector("template");
        const content = template ? template.content : null;

        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const modalDocument = this.querySelector('[role="document"]');
        modalDocument.scrollLeft = (activeMedia.offsetWidth - modalDocument.clientWidth) / 2;

        if (activeMedia.nodeName === "DEFERRED-MEDIA" && content && content.querySelector(".js-youtube")) {
            activeMedia.loadContent();
        }
    }
});
